export default function Hero() {
  return (
    <section id="hero" className="relative min-h-[600px] md:min-h-[700px] flex items-center pt-[72px] overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-background-100 via-background-50 to-accent-50/40"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/30 rounded-full blur-3xl -translate-y-1/3 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/20 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>

      <div className="relative z-10 w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100/70 text-accent-700 text-xs font-semibold mb-5">
              <i className="ri-fire-line"></i>
              <span>今日更新 128 部</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-5xl font-bold text-foreground-950 leading-tight">
              YY漫画 · 你的专属追漫伙伴
            </h1>

            <p className="mt-4 text-base md:text-lg text-foreground-600 leading-relaxed max-w-xl mx-auto lg:mx-0">
              韩漫、日漫海量资源免费全集，智能推荐帮你精准发现好漫画。下拉式阅读，丝滑流畅；实时更新通知，不错过每一话。无论是热血冒险、甜蜜恋爱还是悬疑推理，YY漫画一站式满足你的追漫需求。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-6 text-sm text-foreground-500">
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-book-open-line text-primary-500"></i>
                超过 5 万部漫画
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-group-line text-primary-500"></i>
                日均活跃 80 万漫迷
              </span>
              <span className="flex items-center gap-1.5 whitespace-nowrap">
                <i className="ri-timer-line text-primary-500"></i>
                每日更新 100+ 话
              </span>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a href="#cards" className="px-8 py-3.5 bg-primary-500 text-background-50 font-semibold rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer text-sm">
                立即开始追漫
              </a>
              <a href="#features" className="px-8 py-3.5 border border-foreground-200 text-foreground-700 font-medium rounded-full hover:border-primary-300 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer text-sm">
                了解平台特色
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[500px] aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20warm%20and%20artistic%20illustration%20of%20a%20cozy%20reading%20scene%2C%20an%20open%20manga%20book%20with%20dynamic%20action%20lines%20and%20speech%20bubbles%20floating%20around%2C%20surrounded%20by%20stylized%20comic%20panel%20borders%20in%20soft%20warm%20orange%20and%20cream%20tones%2C%20paper%20texture%20background%2C%20artistic%20editorial%20composition%20with%20gentle%20gradients%20and%20negative%20space%2C%20no%20text%20visible%2C%20modern%20digital%20art%20style%20with%20Japanese%20manga%20aesthetic%20influence&width=1000&height=750&seq=hero-main-2026&orientation=landscape"
                alt="YY漫画阅读体验 - 沉浸式漫画阅读场景"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-500/10 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}